import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Button, Tooltip, Typography } from 'gu-ui-kit'
import styles from 'components/Header/subcomponents/TicketsCounter/ticket-notifications.module.scss'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { SET_DRAWER_STATE } from 'modules/App/types'
import DrawerFooterAnimatedIcon from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/DrawerFooterAnimatedIcon'
import { useSidePanel } from 'modules/SidePanel'
import { TICKETS_PANEL_ID } from 'modules/Tickets/constants'

const TicketsCounter = ({ className, collapse = false }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { toggle } = useSidePanel()
  const { ticketsCounter = 0 } = useSelector(
    (state) => ({
      ticketsCounter: state.notifications?.counters?.ticket,
    }),
    shallowEqual,
  )

  const button = (
    <Button
      className={clsx(styles['tickets-button'], className)}
      variant={'ghost'}
      grey
      size={'s'}
      title={collapse ? undefined : t('tickets::header')}
      startIcon={<DrawerFooterAnimatedIcon name={'messages'} />}
      onClick={() => {
        dispatch({ type: SET_DRAWER_STATE, payload: { opened: false } })
        toggle(TICKETS_PANEL_ID)
      }}
      additionalIcon={
        ticketsCounter > 0 && (
          <Typography
            variant={'Body-10'}
            component={'span'}
            className={'unread'}
          >
            {ticketsCounter}
          </Typography>
        )
      }
    />
  )

  if (collapse) {
    return (
      <Tooltip
        title={t('tickets::header')}
        placement={'right'}
      >
        {button}
      </Tooltip>
    )
  }

  return button
}

export default TicketsCounter

TicketsCounter.propTypes = {
  className: PropTypes.string,
  collapse: PropTypes.bool,
}
